export const CollectionReducerInitialState = {
  collectionsById: {},
  productsCount: null,
};
